
import React, { useState } from 'react';
import {
    EuiButton,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiFieldText,
    EuiFormRow,
    EuiSelect,
    EuiSpacer
} from '@elastic/eui';
import { addBMServer } from '../application/FirebaseConfigs';

interface IProps {
    onClose: () => void;
    onServerAdded: () => void;
}

export const AddServerModal: React.FC<IProps> = ({ onClose, onServerAdded }) => {
    const [serverName, setServerName] = useState('');
    const [serverType, setServerType] = useState('gaming');
    const [app, setApp] = useState('ALL');
    const [isLoading, setIsLoading] = useState(false);

    const types = [
        { value: 'gaming', text: 'Gaming' },
        { value: 'streaming', text: 'Streaming' },
        { value: 'general', text: 'General' },
    ];

    const handleSave = async () => {
        if (!serverName) {
            alert("Please enter a server name");
            return;
        }
        setIsLoading(true);
        try {
            await addBMServer(serverName, "", serverType, app);
            onServerAdded();
            onClose();
        } catch (e) {
            console.error(e);
            alert("Failed to add server");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <EuiModal onClose={onClose}>
            <EuiModalHeader>
                <EuiModalHeaderTitle>
                    <h1>Add New Server</h1>
                </EuiModalHeaderTitle>
            </EuiModalHeader>
            <EuiModalBody>
                <EuiFormRow label="Server Name">
                    <EuiFieldText
                        value={serverName}
                        onChange={e => setServerName(e.target.value)}
                        placeholder="e.g. KR-Gaming-1"
                    />
                </EuiFormRow>
                <EuiFormRow label="Server Type">
                    <EuiSelect
                        options={types}
                        value={serverType}
                        onChange={e => setServerType(e.target.value)}
                    />
                </EuiFormRow>
                <EuiFormRow label="App">
                    <EuiSelect
                        options={[
                            { value: 'ALL', text: 'ALL' },
                            { value: 'KARAK', text: 'KARAK' },
                            { value: 'SPL', text: 'SPL' },
                        ]}
                        value={app}
                        onChange={e => setApp(e.target.value)}
                    />
                </EuiFormRow>
            </EuiModalBody>
            <EuiModalFooter>
                <EuiButton onClick={onClose} color="ghost">Cancel</EuiButton>
                <EuiButton onClick={handleSave} fill isLoading={isLoading}>Save</EuiButton>
            </EuiModalFooter>
        </EuiModal>
    );
};
